import { render } from "./tools.vue?vue&type=template&id=2a0bb8f5&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"

import "./tools.vue?vue&type=style&index=0&id=2a0bb8f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0bb8f5"]])

export default __exports__